import $ from 'jquery';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// import { Carousel } from 'react-responsive-carousel';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import CardNumber from './cardnumber.jsx'
import * as actions from '../../actions/actions.jsx';
import logo from "../../images/Ofx_logo.png";
import services from '../../services/allservices.jsx';
import '../../stylesheet/signin.css';
const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};
const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        keyRecieved: state.publicKey.keyRecieved,
        customerListState: state.customerListReducer.customerListState,
    })

const mapDispatchToProps = dispatch =>
    ({
        fetchPublicKey(keyRecieved) {
            dispatch(
                actions.publicKeyAction(keyRecieved)
            )
        },
        getCustomerList() {
            dispatch(actions.getCustomerListAction())
        },
    })
class Signin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            userName: '',
            password: '',
            disabled: true,
            client: '',
            accountId: '',
            // correctUsername: true,
            // correctPassword: true
        };

        this.onChange = this.onChange.bind(this)
        this.handleLogin = this.handleLogin.bind(this)
        this.onFieldChange = this.onFieldChange.bind(this)
    }
    handleLogin(e) {
  

        // this.props.getCustomerList(this.props.history)
      
        // const {correctPassword ,correctUsername} = this.state
        // if (correctUsername === false) {
        //     this.setState({
        //         correctUsername: false
        //     })
        // }
        // else if (correctPassword === false) {
        //     this.setState({
        //         correctPassword: false
        //     })
        // }

        // else {

        this.setState({
            loader: true
        })
        // const { publicKey } = this.props
        // if (publicKey.status === 200) {
        //     const public_Key = publicKey.body.publickey;
        //     let encrypt = new JSEncrypt();
        //     encrypt.setPublicKey(public_Key);
       

            let _this = this
            let state = {
                userName: this.state.userName,
                password: this.state.password,
                // mobileNumber: this.state.mobileNumber,
                // applicationId: "gmcabs"
            }
            fetch(services.login, {

                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(state)
            })
                .then(
                    function (response) {
                        if (response.status === 200 || response.status === 201) {

                       
                                response.json().then(function (json) {
                                    let exp = json.expiryInMinutes
                                    let expiry = (exp * 60000 + new Date().getTime())

                                    localStorage.setItem('expiryTime', JSON.stringify(expiry))
                                    localStorage.setItem("loginState", true)
                                    localStorage.setItem('memberId', json.memberId);
                                    localStorage.setItem('token', json.token)
                                    localStorage.setItem('accountId', json.accountId);
                                    localStorage.setItem('timeoutvalue', 'first')

                                    localStorage.setItem('lastSuccessfulLogin', json.lastSuccessfulLogin);
                                    localStorage.setItem('lastUnsuccessfulLogin', json.lastUnsuccessfulLogin);
                                  
                                    _this.setState({
                                        loader: false,
                                        accountId:json.accountId,
                                    }, () => {
                                     _this.props.getCustomerList()    
                                    })
                                 
                                    toast.success(response.headers.get('message'), {
                                        position: "top-right",
                                        draggablePercent: 60,
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: false
                                    });

                                    setTimeout(function () {

                                        _this.props.history.push("/cardsearch");
                                    
                                    }, 3000);
                                })  
                                                                           
                                              
                        }
                        else if (response.status === 403 || response.status === 422 )  {
                            _this.setState({
                                loader: false
                            })

                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                        }
                        else if (response.status === 417) {
                            _this.setState({
                                loader: false
                            })
                            document.getElementById("myModal").style.display = "block"

                        }
                        else {
                            _this.setState({
                                loader: false
                            })
    
                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                        }
                       
                    }
                  
                )
            //     if (this.props.customerListState.body && this.props.customerListState.body.length > 0 ) 
            //     this.props.customerListState.body.map((value,i) =>
            //   {
           
            //     localStorage.setItem('serviceUrl',this.props.customerListState.body[0].baseURL)
            //     localStorage.setItem('publicKey',this.props.customerListState.body[0].publickey)
            //     localStorage.setItem('applicationId',this.props.customerListState.body[0].applicationId)
            //     localStorage.setItem('cardBin',this.props.customerListState.body[0].programBIN)
            //     })
        
        }
    
    handleClose = () => {
        document.getElementById("myModal").style.display = "none"
        window.scrollBy(0, 750)
    }
    onEnterPress = (e) => {
    
        if (e.keyCode === 13 && e.shiftKey === false && this.state.userName.length !== 0 && this.state.password.length !== 0) {
           this.setState({
               disabled: false
           })
            e.preventDefault();
            this.handleLogin();
        }
        else {
            this.setState({
                disabled: true
            })
        }
    }

    handelvalidateusername = (e, value) => {

        if (e.target.name === "userName" && value.length !== 0) {
            $(function () {
                $('#uName2').on('keypress', function (e) {
                    if (e.which === 32)
                        return false;
                });
            });

            // if ((e.target.value.length) >= 6) {
            this.setState({
                userName: value
            }, () => {
                if (this.state.userName.length !== 0 && this.state.password.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
            // }else {
            //     this.setState({
            //         correctUsername: false
            //     })
            // }
        } else {
            this.setState({
                disabled: true
            })
        }
    }

    handelvalidatepassword = (e, value) => {
        if (e.target.name === "password" && value.length !== 0) {
            // if ((e.target.value.length) >= 8) {
            this.setState({
                password: value
            }, () => {
                if (this.state.userName.length !== 0 && this.state.password.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
            // }else {
            //     this.setState({
            //         correctPassword: false
            //     })
            // }
        } else {
            this.setState({
                disabled: true
            })
        }
    }
    onChange(e, value) {
        this.setState({
            [e.target.name]: value
        })

    }

    handelmobileNumber = (e, value) => {
        // let addval=  value.trim()

        this.setState({
            mobileNumber: value
        }, () => {
        })

    }
    onFieldChange(e) {

        this.setState({ client: e.target.value }, () => {
         localStorage.setItem('client', this.state.client)
            // this.props.getCurrentUser(this.state.client)

            if (this.state.userName.length !== 0 && this.state.password.length !== 0) {
                this.setState({
                    disabled: false
                })
            } else {
                this.setState({
                    disabled: true
                })
            }
        })
    }
    componentWillMount(){
        if(localStorage.getItem('loginState') === "false" )
        {

            localStorage.clear();
        }
    }

    componentDidMount() {


        $(".toggle-password").click(function () {

            $(this).toggleClass("fa-eye fa-eye-slash");
            var input = $($(this).attr("toggle"));
            if (input.attr("type") === "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });
      
    }
    componentDidUpdate() {
        if (this.props.focus && this.state.userName === '') {

            let uName = document.getElementById("uName2")
            if (uName) {
                uName.focus()
            }
        }
    }
    render() {
        // const height = $(window).height()
        // let { name} = getUser()
        // const { loader, correctUsername, correctPassword } = this.state
        return (
            <div>
                  <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
               
                    <div className="col-sm-12">              
                        <div className=" offset-sm-3 col-sm-7" style={{ background:"#fff",boxShadow: "0px 0px 7px #888888", width: "38%", marginBottom: "20px",marginTop:"10%" }}>
                          <div className="logo text-center" ><img src={logo} alt='' style={{ height: 70, }} /></div>
                            <div className="loginformheading" style={{ textAlign: "center", marginBottom: "10px", paddingTop: "15px" }}>
                                <h4>Customer Care Support </h4>
                            </div>
                            <div className="row input-group" >

                                <div className=" col-sm-2 signinput" style={{ textAlign: "right" }} >
                                    <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                </div>
                                <div className="col-sm-3" style={{marginLeft:"15px"}} >
                                    <TextField

                                        hintText="User Name"
                                        floatingLabelText="User ID"
                                        id="uName"
                                        type="text"
                                        name="userName"
                                        maxLength="20"
                                        onKeyDown={this.onEnterPress}
                                        onChange={this.handelvalidateusername}
                                        className="my-className"
                                        underlineFocusStyle={styles.focusStyle}
                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                        autoFocus={this.props.autoFocus}

                                    />
                                </div>
                            </div>
                            <div className="row input-group" >
                                <div className="col-sm-2 signinput" style={{ textAlign: "right" }} >
                                    <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                </div>
                                <div className="col-sm-8" style={{marginLeft:"15px"}}>
                                    <TextField
                                        hintText="Type Your Password"
                                        floatingLabelText="Password"
                                        autoComplete="new-password"
                                        name="password"
                                        type={"password"}
                                        maxLength="15"
                                        onKeyDown={this.onEnterPress}
                                        onChange={this.handelvalidatepassword}
                                        underlineFocusStyle={styles.focusStyle}
                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                    />
                                    <span toggle="#olpassword" className={`${this.state.toggleIcon} signinput toggle-password`} style={{ marginTop: "40px", position: "absolute", cursor: "pointer" }} onClick={this.toggle}></span>
                                </div>
                            </div>
                           
                            <div className="row input-group"  >
                                <div className="offset-md-5 col-sm-7" style={{ marginTop: '20px', marginBottom: "2%" }} >
                                    <RaisedButton
                                        label="Sign In"
                                        disabled={this.state.disabled}
                                        backgroundColor="#333"
                                        labelColor="#fff"
                                        type="submit"
                                        className="button-submit"
                                        onClick={this.handleLogin}
                                        icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        
        )
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Signin));


// WEBPACK FOOTER //
// ./src/components/register/signin.jsx